const actions = {
  SET_STATE: 'assets/SET_STATE',
  GET_DATA: 'assets/GET_DATA',
  EDIT_ASSET: 'assets/EDIT_ASSET',
  CREATE_ASSET: 'assets/CREATE_ASSET',
  UPDATE_ASSETS_LIST: 'assets/UPDATE_ASSETS_LIST',
  APPEND_ASSETS_LIST: 'assets/APPEND_ASSETS_LIST',

  GET_ASSETS: 'assets/GET_ASSETS',
  PAGE_CHANGED: 'assets/PAGE_CHANGED',
  ROWS_CHANGED: 'assets/ROWS_CHANGED',
  DESIGNATE_ASSET: 'assets/DESIGNATE_ASSET',
  UPDATE_DESIGNATE_ASSET: 'assets/UPDATE_DESIGNATE_ASSET',
}

export default actions
